module.exports = __webpack_public_path__ + "img/maintenance_broken.1ea74d21.svg";